import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { TextField } from "@mui/material";
import { API } from "../assets/staticData";
import SelectLang from "../components/select-lang/SelectLang";
import { DateTimeField, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PromosDataTable from "../components/data-tables/PromosDataTable";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function Promos({ user }) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [lang, setLang] = useState("");

  const [image, setImage] = useState(null);
  const [btnImage, setBtnImage] = useState(null);
  const [mobileBgImage, setMobileBgImage] = useState(null);
  const [userInfo, setuserInfo] = useState();
  const formData = new FormData();
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();
  const hiddenFileInput3 = useRef();

  const [data, setData] = useState({
    title: "",
    desc: "",
    startsAt: "",
    endsAt: "",
    btnL: "",
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/promos?populate=*&sort=createdAt:desc`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setPlatforms(respone.data);
      });
    }

    getData();
  }, [refresh]);

  useEffect(() => {
    async function getData() {
      fetch(`${API}/users/me?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setuserInfo(respone);
      });
    }

    getData();
  }, []);

  if (error) {
    return <div>An error occured: {error.message}</div>;
  }

  const handleInputChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const handleBtnImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setBtnImage(file);
    }
  };

  const handleMobileBgImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setMobileBgImage(file);
    }
  };

  const uploadImage = async (file) => {
    const imageFormData = new FormData();
    imageFormData.append("files", file);

    const response = await fetch(`${API}/upload`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      method: "POST",
      body: imageFormData,
    });

    const result = await response.json();
    return result[0]?.url;
  };

  const uploadItem = async (publish) => {
    if (
      data.title !== "" &&
      data.desc !== "" &&
      image !== null &&
      image !== "" &&
      btnImage !== null &&
      btnImage !== "" &&
      mobileBgImage !== null &&
      mobileBgImage !== "" &&
      lang !== "" &&
      data.startsAt !== "" &&
      data.endsAt !== ""
    ) {
      try {
        const imageUrl = await uploadImage(image);
        const btnImageUrl = await uploadImage(btnImage);
        const mobileBgImageUrl = await uploadImage(mobileBgImage);

        await fetch(`${API}/promos`, {
          headers,
          method: "POST",
          body: JSON.stringify({
            data: {
              ...data,
              lang: lang,
              public: publish ? true : false,
              bg: imageUrl,
              btnBg: btnImageUrl,
              mobileBg: mobileBgImageUrl,
            },
          }),
        });

        setData({
          title: "",
          desc: "",
          startsAt: "",
          endsAt: "",
          btnL: "",
        });
        setImage(null);
        setBtnImage(null);
        setMobileBgImage(null);
        setLang("");
        setOpenAdd(false);
        setRefresh(!refresh);
        toast("The Promo was successfully added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } catch (error) {
        setError(error);
      }
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Promotions Content Settings</h3>
        {user.perms[28].add && (
          <div
            className="addC"
            style={{ minHeight: openAdd ? 500 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="fadeIn"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}>
                <div style={{ width: "100%", display: "flex" }}>
                  <div style={{ width: "50%", height: "100%" }}>
                    <TextField
                      label="Title"
                      sx={{ width: "90%" }}
                      size="small"
                      value={data.title}
                      onChange={(e) => handleInputChange("title", e.target.value)}
                    />
                    <TextField
                      label="Description"
                      sx={{ width: "90%", mt: 2, mb: 2 }}
                      size="small"
                      multiline
                      rows={5}
                      value={data.desc}
                      onChange={(e) => handleInputChange("desc", e.target.value)}
                    />

                    <SelectLang lang={lang} setLang={setLang} />
                  </div>
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 10,
                    }}>
                    <div
                      style={{
                        border: "dashed",
                        borderWidth: 1,
                        borderColor: "grey",
                        height: 135,
                        marginTop: 1,
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderRadius: 5,
                        cursor: "pointer",
                      }}
                      onClick={() => hiddenFileInput.current.click()}>
                      {image ? (
                        <img
                          src={URL.createObjectURL(image)}
                          style={{
                            width: 55,
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img src={addImageIcon} style={{ width: 65, marginBottom: 5 }} />
                      )}
                      <p style={{ color: "#888", fontSize: 13 }}>
                        Click here to add Desktop Background
                      </p>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleImageChange}
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                      />
                    </div>

                    <div
                      style={{
                        margin: "10px auto",
                        border: "dashed",
                        borderWidth: 1,
                        borderColor: "grey",
                        height: 135,
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderRadius: 5,
                        cursor: "pointer",
                      }}
                      onClick={() => hiddenFileInput3.current.click()}>
                      {mobileBgImage ? (
                        <img
                          src={URL.createObjectURL(mobileBgImage)}
                          style={{
                            width: 55,
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img src={addImageIcon} style={{ width: 65, marginBottom: 5 }} />
                      )}
                      <p style={{ color: "#888", fontSize: 13 }}>
                        Click here to add Mobile Background
                      </p>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleMobileBgImageChange}
                        ref={hiddenFileInput3}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="flex"
                  style={{
                    width: "100%",
                    marginTop: 10,
                    justifyContent: "space-between",
                    gap: 10,
                  }}>
                  <div style={{ width: "50%" }}>
                    <TextField
                      label="Button Link"
                      sx={{ width: "90%" }}
                      size="small"
                      value={data.btnL}
                      onChange={(e) => handleInputChange("btnL", e.target.value)}
                    />

                    <div
                      style={{
                        margin: "10px auto",
                        border: "dashed",
                        borderWidth: 1,
                        borderColor: "grey",
                        height: 135,
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderRadius: 5,
                        cursor: "pointer",
                      }}
                      onClick={() => hiddenFileInput2.current.click()}>
                      {btnImage ? (
                        <img
                          src={URL.createObjectURL(btnImage)}
                          style={{
                            width: 55,
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img src={addImageIcon} style={{ width: 65, marginBottom: 5 }} />
                      )}
                      <p style={{ color: "#888", fontSize: 13 }}>
                        Click here to add Button Background
                      </p>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleBtnImageChange}
                        ref={hiddenFileInput2}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>

                  <div
                    className="flex-col"
                    style={{
                      width: "50%",
                      alignItems: "flex-start",
                      paddingLeft: 20,
                    }}>
                    <h3>Start Date & Time</h3>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimeField
                        sx={{ width: "60%", mt: 1 }}
                        label=""
                        defaultValue={dayjs()}
                        format="DD/MM/YYYY HH:mm"
                        onChange={(v) => setData({ ...data, startsAt: v })}
                      />
                    </LocalizationProvider>
                    <h3 className="mt-6">End Date & Time</h3>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimeField
                        sx={{ width: "60%", mt: 1 }}
                        label=""
                        defaultValue={dayjs()}
                        format="DD/MM/YYYY HH:mm"
                        onChange={(v) => setData({ ...data, endsAt: v })}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadItem(true) : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Publish a new Promotion
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div className="flex mt-2 w-[60%] gap-5">
                <div
                  onClick={() => uploadItem(false)}
                  className="flex w-[40%] bg-sky-600 h-[40px] text-white mt-[10px] rounded-md cursor-pointer hover:bg-sky-700 transition-all delay-100">
                  Save as Draft
                </div>
                <div
                  onClick={() => {
                    setOpenAdd(false);
                    setImage(null);
                    setBtnImage(null);
                    setMobileBgImage(null);
                    setLang("");
                    setData({
                      title: "",
                      desc: "",
                      startsAt: "",
                      endsAt: "",
                      btnL: "",
                    });
                  }}
                  className="cancelBTN">
                  Cancel
                </div>
              </div>
            )}
          </div>
        )}

        <PromosDataTable
          data={platforms}
          endpoint={"promos"}
          setRefresh={setRefresh}
          refresh={refresh}
          user={user}
          permNumber={28}
        />
      </div>
    </div>
  );
}
